<style>
  .line {
    height: 100%;
    width: 1px;
    background-color: blue;
    z-index: -1;
  }
</style>

<script>
  import { writable } from 'svelte/store';
  
  export let stepCount = 3;
  /**
   * @type{() => void}
   */
  export let onFinished;
  let activeStep = 0;

  const canGoNext = writable(true); // Store for validation
  const isValidStep = writable(true); // Store for the child to update
  
  $: if (activeStep === stepCount - 1 || $isValidStep) {
    canGoNext.set(true);
  } else {
    canGoNext.set(false);
  }

  function nextStep() {
    if ($canGoNext && activeStep === stepCount - 1) {
      onFinished();
      return;
    } 
    if ($canGoNext && activeStep < stepCount - 1) {
      activeStep++;
      isValidStep.set(false); // Reset validation for next step
      return;
    }
  }

  function prevStep() {
    if (activeStep > 0) {
      activeStep--;
      isValidStep.set(true); // Reset validation for next step
    }
  }
</script>

<div class="flex flex-col">
  <div class="flex">
    <!-- Step Indicators -->
    <div class="relative mr-2 md:mr-8 flex flex-col">
      <div class='w-8 h-8 flex items-center justify-center rounded-full bg-blue-500 mb-4 text-white'>
        {activeStep + 1}/{stepCount}
      </div>
      <div class="">
        <div class="line"></div>
      </div>
    </div>
    
    <!-- Content -->
    <div>
      <slot name="content" activeStep={activeStep} isValidStep={isValidStep}></slot>
    </div>
  </div>
  <div class="grow"></div>
  <!-- Navigation -->
  <div class="flex justify-between mt-8">
    <button class="px-4 py-2 bg-blue-500 text-white" on:click={prevStep} disabled={activeStep === 0}>Назад</button>
    <button class="px-4 py-2 bg-blue-500 text-white" on:click={nextStep} disabled={!$canGoNext}>Напред</button>
  </div>
</div>
